import React from "react";
import {
  CloudContainer,
  TextContainer,
  CloudTitle,
  CloudSubTitle,
  CloudImage,
} from "./styles";

const CloudComplianceSection: React.FC = () => {
  return (
    <CloudContainer>
      <TextContainer>
        <CloudTitle>정부 클라우드 컴퓨팅 서비스 법안 준수</CloudTitle>
        <CloudSubTitle>
          스마일보건은 대한민국 정부에서 정한 클라우드 컴퓨팅 서비스 법안을 100%
          준수하고 있으며, 완벽한 정보 보안을 유지 중입니다
        </CloudSubTitle>
      </TextContainer>
      <CloudImage src="/images/home-cloud.webp" alt="클라우드 동기화" />
    </CloudContainer>
  );
};

export default CloudComplianceSection;
